import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OtpDesktopComponent } from './otp-desktop.component';
import { FormsModule } from '@angular/forms';
import { NgOtpInputModule } from 'ng-otp-input';


@NgModule({
  declarations: [OtpDesktopComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgOtpInputModule
  ],
  exports: [OtpDesktopComponent]
})
export class OtpDesktopModule { }
